import axios from "axios";
import { PARTNER_API_SERVICE_BASE_URL, AUTH_TOKEN } from "../constants/index";
import { getItem } from "../helpers/cookies";

const token = getItem(AUTH_TOKEN);

const apiClient = axios.create({
  baseURL: PARTNER_API_SERVICE_BASE_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
});

export const partnerRestService = async (config) => {
  try {
    const response = await apiClient(config);
    return response?.data;
  } catch (error) {
    console.error("API request error:", error.response?.data || error.message);
  }
};
